import { FloatingFormItem } from '@/components/_common';
import { Col, Form, Input, Modal, ModalProps, Row } from 'antd';
import { ColorResult } from '@uiw/color-convert';
import Circle from '@uiw/react-color-circle';
import { useDefaultEmptyFieldError } from '@/hooks';
import {
  WorkOrderTag,
  WorkOrderTagFormValues,
} from '@/core/domain/workorder/WorkOrderTags/WorkOrdersTags.types';
import {
  useCreateWorkOrderTag,
  useUpdateWorkOrderTag,
} from '@/core/domain/workorder/WorkOrderTags/WorkOrdersTags.hooks';
import { useEffect } from 'react';

interface Props extends Omit<ModalProps, 'onCancel'> {
  tagDetail?: WorkOrderTag;
  onCancel: VoidFunction;
}

export default function TagsWorkOrderModal({
  tagDetail,
  onCancel,
  ...props
}: Props) {
  const [form] = Form.useForm<WorkOrderTagFormValues>();
  const defaultEmptyError = useDefaultEmptyFieldError();

  const { mutateAsync: createMutation, isLoading: createLoading } =
    useCreateWorkOrderTag();
  const { mutateAsync: updateMutation, isLoading: updateLoading } =
    useUpdateWorkOrderTag();

  useEffect(() => {
    if (tagDetail) {
      form.setFieldsValue(tagDetail);
    }
  }, [tagDetail]);

  async function handleOk() {
    const values = await form.validateFields();

    if (tagDetail?.id) {
      await updateMutation({ id: tagDetail.id, ...values });
    } else {
      await createMutation({ ...values });
    }

    handleCancel();
  }

  function handleCancel() {
    form.resetFields();
    onCancel();
  }

  return (
    <Modal
      {...props}
      title={`${!tagDetail?.id ? 'Criação ' : 'Edição '}da etiqueta`}
      width={500}
      okText={!tagDetail?.id ? 'Criar' : 'Editar'}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={createLoading || updateLoading}
    >
      <Form form={form} layout="vertical">
        <Row gutter={[12, 12]}>
          <Col span={24}>
            <FloatingFormItem
              name="name"
              label="Descrição"
              rules={[defaultEmptyError]}
            >
              <Input maxLength={50} />
            </FloatingFormItem>
          </Col>

          <Form.Item
            name="color"
            label="Cor"
            getValueFromEvent={(e: ColorResult) => {
              return e.hex;
            }}
            rules={[defaultEmptyError]}
            valuePropName="color"
          >
            <Circle
              colors={[
                '#F44336',
                '#E91E63',
                '#9C27B0',
                '#673AB7',
                '#3F51B5',
                '#2196F3',
                '#03A9F4',
                '#00BCD4',
                '#009688',
                '#4CAF50',
                '#8BC34A',
                '#CDDC39',
                '#FFEB3B',
                '#FFC107',
                '#FF9800',
                '#FF5722',
                '#795548',
                '#607D8B',
              ]}
            />
          </Form.Item>
        </Row>
      </Form>
    </Modal>
  );
}
